import * as Sentry from "@sentry/react";
import { createBrowserHistory } from "history";

export const sentryHookHistory = createBrowserHistory();

Sentry.init({
  enabled: !!import.meta.env.REACT_APP_ENVIRONMENT,
  environment: import.meta.env.REACT_APP_ENVIRONMENT,
  dsn: "https://92a5d706c5e8286da038de65b30303fd@cerebellum.visikon.com/4",
  enableLogs: true,

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,

  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  integrations: [
    Sentry.consoleLoggingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.reactRouterV5BrowserTracingIntegration({ history: sentryHookHistory })
  ],
});

export const reduxSentryEnhancer = Sentry.createReduxEnhancer();
